import React from 'react'
import { StyleSheet, View } from 'react-native'

import { LeaderboardItem } from 'partials/Leaderboard/subcomponents/LeaderboardItem'

import { Box } from 'widgets/Box'
import { FlatList } from 'widgets/FlatList'
import { Text } from 'widgets/Text'

import { UserType } from 'types/user'

const styles = StyleSheet.create({
  flatList: { marginBottom: 24 },
})

export const Leaderboard = ({
  users,
  loading,
  showPositionNumber = false,
}: {
  users?: UserType[]
  loading?: boolean
  showPositionNumber?: boolean
}) => {
  return (
    <Box flex={1}>
      {users?.length && showPositionNumber && (
        <View testID='HeaderRow'>
          <Box width='100%' flexDirection='row' align='center' justifyContent='flex-end'>
            <Box margin={{ bottom: 'sm' }} width={54} align='center' justifyContent='center'>
              <Text fontSize='xs' color='greyDarker'>
                Rank
              </Text>
            </Box>
            <Box width={1} height='100%' backgroundColor='greyLight' />
            <Box margin={{ bottom: 'sm' }} width={64} align='center' justifyContent='center'>
              <Text fontSize='xs' align='center' color='greyDarker'>
                Upscore
              </Text>
            </Box>
          </Box>
          <Box width='100%' align='center'>
            <Box width='95%' height={1} backgroundColor='greyLight' />
          </Box>
        </View>
      )}

      <FlatList<UserType>
        style={styles.flatList}
        data={users}
        keyExtractor={(item) => `${item?.id}`}
        loading={loading}
        renderItem={({ item, index }) => {
          if (!item) {
            return null
          }
          return (
            <LeaderboardItem
              position={showPositionNumber ? index + 1 : undefined}
              userId={item?.id as string}
            />
          )
        }}
      />
    </Box>
  )
}
